import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { distinctUntilChanged, map, Observable } from 'rxjs';

import { CanvasElement, CanvasElementId } from '@blaze-runtime/engine-domain';
import { countedShareReplay } from '@blaze-shared/shared-util';

import { getElementEntities, getElementsEntityState } from '../+state/elements/elements.selectors';
import { EngineState } from '../+state/engine';
/**
 * Shared read-only view of element entities from the store.
 * Use instead of `store.select(getElementById(id))` in the render tree to avoid thousands of per-id selectors.
 */
@Injectable({ providedIn: 'root' })
export class ElementStoreViewService {
  private readonly store = inject<Store<EngineState>>(Store);

  readonly entities$ = this.store.select(getElementEntities).pipe(countedShareReplay());

  readonly entityState$ = this.store.select(getElementsEntityState).pipe(countedShareReplay());

  getElement(elementId: CanvasElementId): Observable<CanvasElement | undefined> {
    return this.entities$.pipe(
      map((entities) => entities[elementId]),
      distinctUntilChanged(),
    );
  }
}
